import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import ListingPersonsBody from './ListingPersonsBody';
import ListingPersonsData from './ListingPersonsData';
import { ensureCompositionBase } from './utils';

// Normaliza o pathname removendo sufixos de edição ou adição de conteúdo
const normalizePath = (p) => {
  if (!p) return p;
  // Remover query string para avaliar sufixos
  const [raw] = p.split('?');
  if (raw.endsWith('/edit')) return raw.slice(0, -5);
  // if (raw.endsWith('/@@edit')) return raw.slice(0, -7);
  // if (raw.endsWith('/add')) return raw.slice(0, -4);
  return raw;
};

const Edit = (props) => {
  const { data, block, selected, pathname, intl } = props;
  const currentLang = useSelector((state) => state.intl.locale);
  const normalizedPath = ensureCompositionBase({
    ...props,
    path: normalizePath(pathname),
    lang: currentLang,
  });

  return (
    <>
      <ListingPersonsBody
        {...props}
        data={data}
        path={normalizedPath}
        intl={intl}
        isEditMode
      />
      <SidebarPortal selected={selected}>
        <ListingPersonsData key={block} {...props} data={data} block={block} />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
};

export default Edit;
